export default {
    url: '',
    template: `
        <courses-courses-add-general
            course="vm.course"
            fields="vm.fields"
            sites="vm.sites"
            certificates="vm.certificates"
        />
    `,
    resolve: {
        course ($stateParams, CourseResource, COURSE_STATUS_ENUM) {
            if ($stateParams.id !== undefined) {
                return CourseResource.get({ id: $stateParams.id, expand: 'fields,courseI18ns,sites' }).$promise;
            }
            return new CourseResource({
                status: COURSE_STATUS_ENUM.KEYS.INCOMPLETE
            });
        },
        sites (SiteResource) {
            return SiteResource.query({ courseManageSites: true, pageSize: 0 }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        },
        certificates (CompanyResource) {
            return CompanyResource.certificates({ expand: 'activeI18n' });
        }
    },
    controller ($scope, lodash, course, classifiers, sites, certificates, CLASSIFIER_ENUM) {
        $scope.$parent.vm.step = 1;
        this.course = course;
        this.sites = sites;
        this.fields = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.FIELD);
        lodash.forEach(this.fields, (field) => {
            field.activeI18nValue = field.activeI18n.value;
        });
        this.certificates = certificates;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/add/general/index.js